import React from "react";

import { go } from "../../core/route/Route";
import { Page } from "../Page";
import { CurrentForms, WFItem } from "./CurrentForms";
import { useConditional } from "../../core/hooks/useConditional";
import { IconChoiceModal } from "../../core/ui/IconChoice";
import { api } from "../../api/api";
import { newID } from "../../core/utils/unique";
import { SearchBox } from "../../core/form/SearchBox";
import { entity } from "../../types";
import { Icon } from "../../core/ui/icons";
import { Table } from "../../core/ui/Table";
import { CustomCol } from "../../layout/TableCells";

export function Dashboard(props: {

}) {

	const [token, setToken] = React.useState("");

	const newModal = useConditional(() => {
		return (
			<IconChoiceModal
				title="Create"
				size="width-50vw"
				options={[
					{
						id: "company-new",
						icon: "company",
						title: "Company" 
					},
					{
						id: "trust-new",
						icon: "trust",
						title: "Trust"
					},
					{
						id: "smsf-new",
						icon: "smsf",
						title: "SMSF"
					},
					{
						id: "legal-document",
						icon: "legal_document",
						title: "Legal Document"
					},
					{
						id: "test",
						icon: "add",
						title: "Test!!"
					},
					{
						id: "ra51",
						icon: "add",
						title: "RA51 - Test"
					},
				]}
				onCancel={newModal.close}
				onChoose={(option) => {
					newModal.close();
					if (!option.id) return;

					api.account_wf_start({
						def: option.id,
						deleted: 0,
					}).then((newObj: any) => {
						// if we have a form in the new obj then auto redirect immediately to editing it
						if (newObj && newObj.resources && newObj.resources.forms && newObj.resources.forms.length > 0) {
							const fid = newObj.resources.forms[0];
							go(`/form/${fid}/`);
						} else {
							setToken(newID());
						}
					}).catch(() => {

					});

				}}
			/>
		)
	});

	return (
		<Page 
			compact={true}
			
			title={{
				text: "Dashboard",
				//icon: "chart_color",
				buttons: [
					{ id: "create", title: "Create" },
					{ id: "entities", title: "Entities", url: "/entity/" },
					{ id: "profile", title: "My Account", url: "/profile/" },
					{ id: "billing", title: "Billing", url: "/billing/" },
					{ id: "settings", title: "Settings", role: "admin", url: "/admin/settings/" },
				],
			}}

			onButton={(btn) => {
				if (btn.url) {
					go(btn.url);
				
				} else if (btn.id === "create") {
					newModal.show({});

				}
			}}
		>
			<h1>Dashboard</h1>

			<CurrentForms key={token} />

			{newModal.render()}
		</Page>
	);
}



export function CreateNewModal(props: {

}) {
	
}